import React from 'react';

import { Grid, IconButton, Typography } from '@mui/material';
import { Box } from '@mui/system';

import {
  currency,
  fallbackText,
  language,
  Language,
  userGeneral,
  userPharmacyInfo,
} from '@pharmaplan/common';

import { DateTime } from 'luxon';
import { Close } from '@mui/icons-material';

import useProfessional from '../../../hooks/Professional/useProfessional';
import { useAppSelector } from '../../../hooks/useAppSelector';
import { MomentTimeFormats } from '../../../helpers/Constants';
import { useAppDispatch } from '../../../hooks/useAppDispatch';
import { resetDialog } from '../../../reducers/dialogReducer';
import strings from '../../../localization';

import styles from './styles';

const Row = ({ label, value }: { label: string; value: number | string }) =>
  (
    <Grid container xs={12} sx={{ mb: 1.5, alignItems: 'center' }}>
      <Grid item xs={8}>
        <Typography sx={styles.label}>
          {label}
          :
        </Typography>
      </Grid>
      <Grid item xs={4}>
        <Typography sx={styles.value}>{value || '-'}</Typography>
      </Grid>
    </Grid>
  );

const PromoDetails = () => {
  const dispatch = useAppDispatch();

  const userLang = useAppSelector(language);
  const isFr = userLang === Language.fr;

  const { isProfessional } = useProfessional();

  const pharmacistInfo = useAppSelector(userGeneral);
  const pharmacyInfo = useAppSelector(userPharmacyInfo);

  const info = isProfessional ? pharmacistInfo : pharmacyInfo;

  const offerLabel = isProfessional
    ? strings.promoHourlyBonus
    : strings.promoHourlyRate;

  const { validUntil, creditsLeft = 0, promoHourlyRate = 0 } = info ?? {};

  const luxonDate = DateTime.fromISO(validUntil ?? '', {
    setZone: true,
  });
  const day = luxonDate.toFormat(MomentTimeFormats.day);
  const month = luxonDate.toFormat(MomentTimeFormats.shortMonthName);

  const handleClose = () => {
    dispatch(resetDialog());
  };

  return (
    <Box sx={styles.container(isFr)}>
      <Typography sx={styles.title}>
        <Typography component="span" sx={{ fontSize: 26 }}>
          🎉
        </Typography>
        {` ${strings.promoAvailable}`}
      </Typography>

      <IconButton size="small" sx={styles.closeIcon} onClick={handleClose}>
        <Close />
      </IconButton>

      <Box sx={{ pb: 3 }}>
        <Row label={strings.credits} value={creditsLeft} />
        <Row
          label={offerLabel}
          value={`${currency}${promoHourlyRate}` || fallbackText}
        />
        <Box sx={styles.hurryContainer}>
          <Typography sx={[styles.hurryText, styles.hurryMargin]}>
            {strings.hurryOfferEndsFormat}
          </Typography>
          <Typography sx={styles.hurryText}>{`${day} ${month}`}</Typography>
        </Box>
      </Box>
    </Box>
  );
};
export default PromoDetails;
